"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var useAutoFocus_1 = __importDefault(require("../../utils/useAutoFocus"));
var SelectFieldSingle_1 = __importDefault(require("./select/SelectFieldSingle"));
var SelectFieldMulti_1 = __importDefault(require("./select/SelectFieldMulti"));
var Form_1 = require("./Form");
var useDisabled_1 = __importDefault(require("./useDisabled"));
var DoorEffect_1 = __importDefault(require("../DoorEffect"));
var SelectField = function (_a) {
    var _b = _a.allWordsMatch, allWordsMatch = _b === void 0 ? false : _b, allowEmpty = _a.allowEmpty, ariaLabel = _a.ariaLabel, _c = _a.autoFocus, autoFocus = _c === void 0 ? false : _c, children = _a.children, _d = _a.childIsLabel, childIsLabel = _d === void 0 ? true : _d, className = _a.className, _e = _a.clearValueOnOpen, clearValueOnOpen = _e === void 0 ? true : _e, _f = _a.creatable, creatable = _f === void 0 ? false : _f, _g = _a.creatableLabel, creatableLabel = _g === void 0 ? "" : _g, _h = _a.createClickNeeded, createClickNeeded = _h === void 0 ? true : _h, disabled = _a.disabled, imageIconPath = _a.imageIconPath, _j = _a.isDestroyable, isDestroyable = _j === void 0 ? false : _j, initialDisplay = _a.initialDisplay, _k = _a.multiple, multiple = _k === void 0 ? false : _k, name = _a.name, _l = _a.fixedValue, fixedValue = _l === void 0 ? false : _l, onChange = _a.onChange, onTextChanged = _a.onTextChanged, onSelectedField = _a.onSelected, onUnselected = _a.onUnselected, options = _a.options, _m = _a.placeholder, placeholder = _m === void 0 ? "" : _m, _o = _a.required, required = _o === void 0 ? false : _o, validator = _a.validator, value = _a.value, _p = _a.removePlacholder, removePlacholder = _p === void 0 ? false : _p;
    var _q = react_1.useState(false), openShareWith = _q[0], setOpenShareWith = _q[1];
    var inputRef = react_1.default.createRef();
    var onFocus = useAutoFocus_1.default(autoFocus, inputRef);
    useDisabled_1.default(name, disabled);
    var onSelected = function () {
        setOpenShareWith(true);
        if (onSelectedField) {
            onSelectedField();
        }
    };
    var onCloseAction = function () {
        setOpenShareWith(false);
    };
    var context = Form_1.useForm();
    var passed = __assign(__assign({}, context), { allWordsMatch: allWordsMatch,
        allowEmpty: allowEmpty,
        ariaLabel: ariaLabel,
        autoFocus: autoFocus,
        childIsLabel: childIsLabel,
        clearValueOnOpen: clearValueOnOpen,
        creatable: creatable,
        creatableLabel: creatableLabel,
        createClickNeeded: createClickNeeded,
        disabled: disabled,
        imageIconPath: imageIconPath,
        initialDisplay: initialDisplay,
        inputRef: inputRef,
        isDestroyable: isDestroyable,
        name: name,
        fixedValue: fixedValue,
        onCloseAction: onCloseAction,
        onTextChanged: onTextChanged,
        onFocus: onFocus,
        options: options,
        onSelected: onSelected,
        onUnselected: onUnselected,
        placeholder: placeholder,
        removePlacholder: removePlacholder,
        required: required, selectRef: react_1.default.createRef() });
    return (react_1.default.createElement("label", { className: classnames_1.default("chq-ffd", className), htmlFor: name },
        childIsLabel && (react_1.default.createElement("span", { className: "chq-ffd--lb" }, children)),
        multiple
            ? (react_1.default.createElement("div", null,
                react_1.default.createElement(SelectFieldMulti_1.default, __assign({}, passed, { onChange: onChange, validator: validator, value: value }), !childIsLabel && (react_1.default.createElement(DoorEffect_1.default, { className: "chq-ffd--sl--opts", open: openShareWith },
                    react_1.default.createElement("div", { className: "chq-ffd--lb" }, children))))))
            : (react_1.default.createElement("div", null,
                react_1.default.createElement(SelectFieldSingle_1.default, __assign({}, passed, { onChange: onChange, validator: validator, value: value }), !childIsLabel && (react_1.default.createElement(DoorEffect_1.default, { className: "chq-ffd--sl--opts", open: openShareWith },
                    react_1.default.createElement("div", { className: "chq-ffd--lb" }, children))))))));
};
exports.default = SelectField;
